module.exports = __webpack_public_path__ + "img/lestnica_vnutrennyaya.f69cc7ba.svg";